// extracted by mini-css-extract-plugin
export var quantityInput = "_du-0";